import {Injectable} from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {SessionActions} from '../session/session-actions';
import {createAction} from '../create-action';
import {CurrentScorecardActions} from './current-scorecard-actions';
// import { createEffect } from 'node_modules/@ngrx/effects';
import { map } from 'rxjs/operators';



/**
 * Created by ashok on 11/05/17.
 */

@Injectable()
export class CurrentScorecardEffects {
    constructor(private actions$: Actions) {
    }
    //On logout clear the current scorecard
    // @Effect()
    // logout$ = this.actions$.ofType(SessionActions.LOGOUT)
    //     .map(()=>{
    //         return createAction(CurrentScorecardActions.CLEAR_CURRENT_SCORECARD);
    //     });



    logout$ = createEffect(() =>
    this.actions$.pipe(
        ofType(SessionActions.LOGOUT),
        map(() => {
            return createAction(CurrentScorecardActions.CLEAR_CURRENT_SCORECARD);
        })
    )
);
}
